import { Component } from "@angular/core";
import { FieldWrapper } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./page.component.html",
    styleUrls: ["./page.component.css"],
})
export class PageComponent extends FieldWrapper {}
